import { render, staticRenderFns } from "./NumberList.vue?vue&type=template&id=04e770b8&scoped=true"
import script from "./NumberList.vue?vue&type=script&lang=ts"
export * from "./NumberList.vue?vue&type=script&lang=ts"
import style0 from "./NumberList.vue?vue&type=style&index=0&id=04e770b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e770b8",
  null
  
)

export default component.exports